module.exports = require('./helpers/bundle-url').getBundleURL('1l2aU') + "logo.7718c6df.svg";